import React from 'react';
import "../../css/CenteredWrapper.css"

const CenteredWrapper = ({ children }) => {
  return (
    <div className="centered-wrapper">
      {children}
    </div>
  );
};

export default CenteredWrapper;